import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import styles from "./NotificationDrawer.module.scss";
import axios from "axios";
import Modal from ".././controls/modal/Modal";
import Skeleton from "react-loading-skeleton";
import CheckboxInput from ".././controls/checkbox/Checkbox";
import DropDown from ".././controls/dropdown/DropdownFluent";
import { generalActions } from "../../store/actions";
import {
  BASE_URL,
  URL_CLIENTS,
  URL_PROJECTS,
  URL_PORTFOLIO,
  URL_SEARCH_REQUEST,
  URL_RISK,
  URL_TASK,
  URL_SEARCH_TASK,
  URL_CLIENT_PROGRAMS,
  URL_SEARCH_USERS,
  URL_BUDGETS,
} from "../../store/services/URL";
import {
  TeachingPopover,
  Avatar,
  Button,
  TeachingPopoverBody,
  TeachingPopoverHeader,
  TeachingPopoverSurface,
  TeachingPopoverTrigger,
  partitionAvatarGroupItems,
} from "@fluentui/react-components";
import {
  AddIcon,
  AddPersonIcon,
  AddTaskSvg,
  CalendarIcon,
  DeleteRedSvg,
  FilterCross,
  ClockIcon,
  HourlyRateIcon,
  MeetingsClockIcon,
} from "../../modules/default-svg";
import CustomButton from "../../components/controls/button/Button";
import Input from "../../components/controls/input/customInput/CustomInput";
import Style from "../../views/changeRequest/ChangeRequest.module.scss";
import InputUnderline from "../../components/controls/input/InputUnderline";
import {
  changeRequestStatus,
  changeRequestTypes,
  changeRequestPriorities,
  riskStatusOptions,
  riskProbability,
  riskImpact,
  taskStatusOptions,
  taskDependencyStatus,
  generateRandomString,
  languages,
  timezones,
  taskPriorityOptions,
  getLabelByType,
  riskStatus,
} from "../../helpers/utils";
import RiskItem from "../../views/changeRequest/RiskItems";
import Searchable from "../../components/controls/select/CustomSelect";
import { getAccountCurrency, isDateGreaterThan } from "../../utils/systemSettings";
import service from "../../store/services/changeRequests.service";
import userService from "../../store/services/user.service";
import projectService from "../../store/services/projects.service";
import generalService from "../../store/services/general.service";
import { dateOnlyFormatted } from "../../utils/systemSettings";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import riskService from "../../store/services/risks.service";
import ModalCheckbox from "../../components/controls/modalcheckbox/ModalCheckbox";
import scopeService from "../../store/services/scope.service";
import budgetService from "../../store/services/budgets.service";
import { scopeStatusLoading } from "../../store/selectors/scope.selector";
import { budgetLoading } from "../../store/selectors/budgets.selector";
import { updateBudgetRequest } from "../../store/actions/budgets.actions";
import { communicationPlanStatusLoading } from "../../store/selectors/communications.selector";
import { updateCommunicationPlanRequest } from "../../store/actions/communications.actions";
import { updateRiskRequest } from "../../store/actions/risks.actions";
import { riskStatusLoading } from "../../store/selectors/risks.selector";
import { updateChangeRequest } from "../../store/actions/changeRequests.actions";
import { changeRequestLoading } from "../../store/selectors/changeRequests.selector";
import { roles, userStatusLoading } from "../../store/selectors/user.selector";
import HourlyEstimation from "../../components/hourlyEstimation/HourlyEstimation";
import AddCapacity from "../../views/scopeOverview/AddCapacity";
import {
  resourcesShiftsRequest,
  getScope,
  updateTask,
  updateScopeRequest,
} from "../../store/actions/scope.actions";
import {
  loading,
  reminderDetail,
} from "../../store/selectors/general.selector";
import {
  clearReminder,
  getReminders,
} from "../../store/actions/general.actions";
import Pencil from "../../assets/svg/pencil.svg";
import Clock from "../../assets/svg/Clock.svg";
import NotesIcon from "../../assets/svg/notes.svg";
import {
  AvatarGroup,
  AvatarGroupItem,
  AvatarGroupPopover,
} from "@fluentui/react-components";
import CustomSelect from "../../components/controls/select/CustomSelect";
import { checkEmail } from "../../utils/formValidation";
import PhoneInput from "../../components/controls/input/phoneInput/PhoneInput";
import { updateUserRequest, getRoles } from "../../store/actions/user.actions";
import moment from "moment";
import RichTextEditor from "../richTextEditor/RichTextEditor";
import AssociatedRisks from "../../views/risk/AssociatedRisks";
import ModalCheckboxWarning from "../controls/modalcheckbox/ModalCheckboxWarning";
import TaskDependencies from "../taskDependencies/TaskDependencies";
import DateRangeWithDuration from "../dateRangeWithDuration/DateRangeWithDuration";
import ReminderModal from "../controls/modal/reminder/Reminder";
import EntityFileUpload from "../controls/fileUpload/EntityFileUpload";

const Resources = (props) => {
  const { error, setIsModalOpen, notification } = props;
  const dispatch = useDispatch();
  const allRoles = useSelector(roles);
  const loading = useSelector(userStatusLoading);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [userName, setUserName] = useState("");
  const [title, setTitle] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phoneNumber, setPhone] = useState("");
  const [hourlyRate, setHourlyRate] = useState("");
  const [maxHours, setMaxHours] = useState("");
  const [operationalCapacity, setOperationalCapacity] = useState("");
  const [projectCapacity, setProjectCapacity] = useState("");
  const [language, setLanguage] = useState("");
  const [timezone, setTimezone] = useState("");
  const [responsibilities, setResponsibilities] = useState("");
  const [manager, setManager] = useState(null);
  const [role, setRoles] = useState([]);
  const [isExternal, setIsExternal] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [defaultRoles, setDefaultOptions] = useState([]);
  const [defaultRoleValues, setDefault] = useState("");
  const [managers, setManagers] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);
  const [optionMessage, setOptionMessage] = useState("");
  const [formErrors, setFormErrors] = useState({
    email: "",
    firstName: "",
    lastName: "",
    password: "",
    userName: "",
    role: "",
  });

  useEffect(() => {
    setRoles(allRoles);
  }, [allRoles]);

  const handleGeneratePassword = () => {
    const randomString = generateRandomString();
    setPassword(randomString);
  };

  const handleSave = () => {
    const errors = {};
    if (!firstName) errors["firstName"] = `The FirstName field is required.`;
    if (!lastName) errors["lastName"] = `The LastName field is required.`;
    if (!userName) errors["userName"] = `The UserName field is required.`;
    if (!email) errors["email"] = `The Email field is required.`;
    if (checkEmail(email)) errors["email"] = checkEmail(email);
    if (role.length === 0) errors["role"] = `The Roles field is required.`;
    setFormErrors(errors);
    if (Object.keys(errors).length) {
      return;
    }
    const payload = {
      firstName,
      lastName,
      fullName: `${firstName} ${lastName}`,
      userName,
      title,
      email,
      phoneNumber,
      hourlyRate,
      maxHours,
      operationalCapacity,
      projectCapacity,
      language,
      timezone,
      responsibilities,
      managerId: manager && manager.value,
      roles: role,
      isExternal,
      isActive,
    };
    dispatch(updateUserRequest({ id: notification.id, payload }));
  };

  useEffect(() => {
    // if(error !== "" || error !== null) {
    //     setFormErrors({});
    //     Object.keys(error).forEach((key) => {
    //         if (key === 'FirstName') {
    //             setFormErrors((prevErrors) => ({
    //               ...prevErrors,
    //               firstName: error[key][0]
    //             }));
    //         }
    //         if (key === 'LastName') {
    //             setFormErrors((prevErrors) => ({
    //               ...prevErrors,
    //               lastName: error[key][0]
    //             }));
    //         }
    //         if (key === 'UserName') {
    //             setFormErrors((prevErrors) => ({
    //               ...prevErrors,
    //               userName: error[key][0]
    //             }));
    //         }
    //         if (key === 'Email') {
    //             setFormErrors((prevErrors) => ({
    //               ...prevErrors,
    //               email: error[key][0]
    //             }));
    //         }
    //         if (key === 'Password') {
    //             setFormErrors((prevErrors) => ({
    //               ...prevErrors,
    //               password: error[key][0]
    //             }));
    //         }
    //     });
    // } else {
    //     setFormErrors({});
    // }
  }, [error]);

  useEffect(() => {
    if (firstName) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        firstName: "",
      }));
    }
    if (lastName) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        lastName: "",
      }));
    }
    if (userName) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        userName: "",
      }));
    }
    if (email) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        email: "",
      }));
    }
    if (role.length > 0) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        role: "",
      }));
    }
  }, [firstName, lastName, userName, email, role, password]);

  const fetchUserData = async () => {
    userService
      .fetchSingleUserDataRequest(notification.id)
      .then((userData) => {
        setFirstName(userData.firstName);
        setLastName(userData.lastName);
        setUserName(userData.userName);
        setTitle(userData.title);
        setEmail(userData.email);
        setPhone(userData.phoneNumber);
        setHourlyRate(userData.hourlyRate);
        setMaxHours(userData.maxHours);
        setOperationalCapacity(userData.operationalCapacity);
        setProjectCapacity(userData.projectCapacity);
        setLanguage(userData.language);
        setTimezone(userData.timezone);
        setResponsibilities(userData.responsibilities);
        userData.manager
          ? setManager({
              label: userData.manager.name,
              value: userData.manager.id,
            })
          : setManager(null);
        const selectedOptions = userData.roles.map((option) => option.id);
        // const defaultVal = allRoles.filter(role =>
        //     userData.roles.some(def => def.id === role.id)
        // ).map(obj => ({
        //     label: obj.name,
        //     value: obj.id,
        // }))
        const defaultVal = userData.roles.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setDefaultOptions(defaultVal);
        const existingOptions = userData.roles.filter((defaultObj) =>
          allRoles.some((option) => option.id === defaultObj.id)
        );
        const namesString = existingOptions.map((obj) => obj.name).join(", ");
        setDefault(namesString);
        setRoles(selectedOptions);
        setIsExternal(userData.isExternal);
        setIsActive(userData.isActive);
      })
      .catch((error) => console.error("Error fetching user data:", error));
  };

  const handleCancel = () => {
    setFormErrors({});
    setPassword("");
    setIsModalOpen(false);
    setManager(null);
  };

  useEffect(() => {
    if (Object.keys(notification).length > 0) {
      fetchUserData();
    } else {
      setFirstName("");
      setLastName("");
      setUserName("");
      setTitle("");
      setEmail("");
      setPassword("");
      setPhone("");
      setHourlyRate("");
      setMaxHours("");
      setOperationalCapacity("");
      setProjectCapacity("");
      setLanguage("");
      setTimezone("");
      setResponsibilities("");
      setManager(null);
      setRoles([]);
      setDefaultOptions([]);
      setDefault("");
      setIsExternal(false);
      setIsActive(true);
    }
  }, [notification]);

  const handleInputChange = (value, name) => {
    if (name === "firstName") setFirstName(value);
    if (name === "lastName") setLastName(value);
    if (name === "userName") setUserName(value);
    if (name === "email") setEmail(value);
    if (name === "password") setPassword(value);
    if (name === "role") setRoles(value);
  };

  const searchHandler = (value) => {
    if (value === "") {
      setManagers([]);
      return;
    }
    userService
      .searchUserDataRequest(value)
      .then((res) => {
        if (res.length > 0) {
          const transformedArray = res.map((obj) => ({
            label: obj.name,
            value: obj.id,
            image: obj.profilePictureUrl,
          }));
          setManagers(transformedArray);
        }
      })
      .catch((err) => {
        setManagers([]);
      });
  };

  const searchRoleHandler = (value) => {
    if (value === "") {
      setRoleOptions([]);
      return;
    }
    userService
      .searchRoleDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setRoleOptions(transformedArray);
        setOptionMessage("");
      })
      .catch((err) => {
        setRoleOptions([]);
        setOptionMessage("No result");
      });
  };

  useEffect(() => {
    dispatch(getRoles({ page: 1, size: 10 }));
  }, []);

  const validateEmail = (e) => {
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      email: checkEmail(e.target.value),
    }));
  };

  const formBody = () => {
    return (
      <>
        <h5 className="mb-4">General Info</h5>
        <div className={`d-flex align-items-center w-30 mb-3`}>
          <ModalCheckbox
              label={isExternal ? "External" : "Mark as External"}
              checked={isExternal}
              setChecked={setIsExternal}
            />
        </div>
        <div>
          <div className="d-flex align-items-start w-100 mb-3">
            <Input
              inputwd="w-50 me-3"
              icon={false}
              placeholder="Enter name"
              value={firstName}
              type="text"
              handleChange={(value) => handleInputChange(value, "firstName")}
              label="First name"
              cssClass={Style.inputField}
              errorMessage={formErrors.firstName}
              isRequired
            />
            <Input
              inputwd="w-50"
              icon={false}
              placeholder="Enter name"
              value={lastName}
              type="text"
              handleChange={(value) => handleInputChange(value, "lastName")}
              label="Last name"
              cssClass={Style.inputField}
              errorMessage={formErrors.lastName}
              isRequired
            />
          </div>
          <div className="d-flex align-items-start w-100 mb-3">
            <Input
              inputwd="w-50 me-3"
              icon={false}
              placeholder="Enter username"
              value={userName}
              type="text"
              handleChange={(value) => handleInputChange(value, "userName")}
              label="User name"
              cssClass={Style.inputField}
              errorMessage={formErrors.userName}
              isRequired
            />
            <Input
              inputwd="w-50"
              icon={false}
              placeholder="Enter title"
              value={title}
              type="text"
              handleChange={setTitle}
              label="Title"
              cssClass={Style.inputField}
            />
          </div>
          <div className="d-flex align-items-start w-100 mb-3">
            <Input
              inputwd="w-50 me-3"
              icon={false}
              placeholder="Enter email"
              value={email}
              type="email"
              handleChange={(value) => handleInputChange(value, "email")}
              handleBlur={(e) => validateEmail(e)}
              label="Email"
              cssClass={Style.inputField}
              errorMessage={formErrors.email}
              isRequired
            />
            <PhoneInput
              phoneWd="w-50"
              label="Phone Number"
              value={phoneNumber}
              handleChange={setPhone}
              placeholder="Enter phone"
            />
          </div>
        </div>

        <h5 className="mb-4">Advance Info</h5>
        <div>
        <div className={`d-flex align-items-start w-100 mb-3`}>
            <Searchable
              label="Manager"
              SelectText="Manager"
              selectWd="w-50 me-3"
              persona={true}
              searchText={searchHandler}
              options={managers}
              defaultVal={manager}
              onChange={(e) => setManager(e)}
              creatable={true}
              setCreated={setManager}
            />
            <Searchable
              label="Roles"
              SelectText="Role"
              selectWd="w-50"
              isRequired
              multiselect={true}
              searchText={searchRoleHandler}
              options={roleOptions}
              defaultVal={defaultRoles}
              onChange={(value) => handleInputChange(value, "role")}
              errorMessage={formErrors.role}
              optionMessage={optionMessage}
            />
          </div>
          <div className="d-flex align-items-start w-100 mb-3">
            <Input
              inputwd="w-50 me-3"
              icon={<HourlyRateIcon />}
              inputClass="Input_Icon"
              placeholder="Enter hourly rate"
              value={hourlyRate}
              type="number"
              handleChange={setHourlyRate}
              label="Hourly rate"
            />
            <Input
              inputwd="w-50"
              icon={<ClockIcon />}
              inputClass="Input_Icon"
              placeholder="Enter max hours"
              value={maxHours}
              type="number"
              handleChange={setMaxHours}
              label="Max hours"
            />
          </div>
          <div className="d-flex align-items-start w-100 mb-3">
            <Input
              inputwd="w-50 me-3"
              icon={false}
              placeholder="Operational capacity"
              value={operationalCapacity}
              type="number"
              handleChange={setOperationalCapacity}
              label="Operational capacity"
              cssClass={Style.inputField}
            />
            <Input
              inputwd="w-50"
              icon={false}
              placeholder="Project capacity"
              value={projectCapacity}
              type="number"
              handleChange={setProjectCapacity}
              label="Project capacity"
              cssClass={Style.inputField}
            />
          </div>
          <div className={`d-flex align-items-start w-100 mb-3`}>
            <DropDown
              dropDownwd="w-50 me-3"
              label="Language"
              options={languages}
              defaultVal={language}
              onChange={setLanguage}
            />
            <DropDown
              dropDownwd="w-50"
              label="Time Zone"
              options={timezones}
              defaultVal={timezone}
              onChange={setTimezone}
            />
          </div>

          <div className={` d-flex justify-content-between align-items-center mb-3`}>
            <RichTextEditor
              label="Responsabilities"
              content={responsibilities}
              onChange={setResponsibilities}
            />
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Modal
        title="Resource"
        handleCancel={handleCancel}
        handleSave={handleSave}
        body={formBody()}
        isLoading={loading}
        size="large"
        saveBtnLabel="Save"
        cancelBtnLabel="Cancel"
      />
    </>
  );
};

const Task = (props) => {
  const {
    scopeID,
    allTasks,
    getScopeItemsRequest,
    updateTaskRequest,
    error,
    resourcesShiftsRequest,
    allResourceShifts,
    notification,
    loader,
    setIsModalOpen,
  } = props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const id = localStorage.getItem("id");
  const [project, setProject] = useState({});
  const [isCreate, setIsCreate] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isPopoverOpen2, setIsPopoverOpen2] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [perPageItems, setPerPage] = useState(10);
  const [pageNum, setPageNum] = useState(1);
  const [data, setData] = useState([]);
  const [overviewHeaderFields, setOverviewHeaderFields] = useState([]);
  const [headerTitle, setHeaderTitle] = useState([]);
  const [currentScope, setCurrentScope] = useState({});
  const [name, setName] = useState("");
  const [taskProgress, setTaskProgress] = useState(0);
  const [risks, setRisks] = useState([]);
  const [showManagerDropdown, setShowManagerDropdown] = useState(false);
  const [resources, setResources] = useState([]);
  const [resourceOptions, setResourceOptions] = useState([]);
  const [assignedResources, setAssignedResources] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [completionDate, setCompletionDate] = useState("");
  const [hours, setHours] = useState("");
  const [totalBudget, setTotalBudget] = useState(0);
  const [totalCapacity, setTotalCapacity] = useState(0);
  const [status, setStatus] = useState(0);
  const [priority, setPriority] = useState(0);
  const [budget, setBudget] = useState("");
  const [phase, setPhase] = useState("");
  const [scopes, setScopes] = useState([]);
  const [scope, setScope] = useState("");
  const [refId, setRefId] = useState("");
  const [description, setDescription] = useState("");
  const [isDraft, setIsDraft] = useState(false);
  const [isCritical, setIsCritical] = useState(false);
  const [isTaskMilestone, setIsTaskMilestone] = useState(false);
  const [isInWsr, setIsInWsr] = useState(false);
  const [taskScope, setTaskScope] = useState(null);
  const [taskDependencies, setTaskDependencies] = useState([]);
  const [taskDependenciesDto, setTaskDependenciesDto] = useState([]);
  const [isResolveConflict, setIsResolveConflict] = useState(false);
  const [selectedResources, setSelectedResources] = useState([]);
  const [setting] = useState(settings);
  const [task, setTask] = useState("");
  const [allocations, setAllocations] = useState([]);
  const [dateRange, setDateRange] = useState();
  const [formErrors, setFormErrors] = useState({
    name: "",
    startDate: "",
    endDate: "",
    completionDate: "",
  });
  const [attachments, setAttachments] = useState([]);

  const getRequestPriority = (type) => {
    switch (type) {
      case 0:
        return "Low";
      case 1:
        return "Moderate";
      case 2:
        return "High";
      default:
        return "";
    }
  };

  const getRequestStatus = (type) => {
    switch (type) {
      case 0:
        return "In Progress";
      case 1:
        return "Monitoring";
      case 2:
        return "Slipping";
      case 3:
        return "Completed";
      default:
        return "";
    }
  };

  const setRequestPriority = (type) => {
    switch (type) {
      case "Low":
        return 0;
      case "Moderate":
        return 1;
      case "High":
        return 2;
      default:
        return 0;
    }
  };

  const setRequestStatus = (type) => {
    switch (type) {
      case "In Progress":
        return 0;
      case "Monitoring":
        return 1;
      case "Slipping":
        return 2;
      case "Completed":
        return 3;
      default:
        return 0;
    }
  };

  useEffect(() => {
    if (error && error !== "") {
      Object.keys(error).forEach((key) => {
        if (key === "Name") {
          setFormErrors((prevErrors) => ({
            ...prevErrors,
            name: error[key][0],
          }));
        }
      });
    }
  }, [error]);

  useEffect(() => {
    scopeService
      .getScopeDetailsRequest({ id: scopeID })
      .then((scopeDetails) => {
        let ownerName = "";
        let ownerImage = "";
        let creatorName = "";
        let creatorImage = "";
        if (scopeDetails.owner) {
          ownerName = scopeDetails.owner.name;
          ownerImage = scopeDetails.owner.image ? scopeDetails.owner.image : "";
        }
        if (scopeDetails.creator) {
          creatorName = scopeDetails.creator.name;
          creatorImage = scopeDetails.creator.image
            ? scopeDetails.creator.image
            : "";
        }
        const scopeTitle = {
          name: scopeDetails.name,
          image: scopeDetails.image,
        };
        setCurrentScope({ label: scopeDetails.name, value: scopeDetails.name });
        setHeaderTitle(scopeTitle);
        setProject(scopeDetails.project);
        const res = [
          { label: "Created By", name: creatorName, image: creatorImage },
          { label: "Scope Manager", name: ownerName, image: ownerImage },
          {
            label: "Start Date",
            name: scopeDetails.startDate
              ? dateOnlyFormatted(setting, scopeDetails.startDate)
              : "---",
          },
          {
            label: "End Date",
            name: scopeDetails.endDate
              ? dateOnlyFormatted(setting, scopeDetails.endDate)
              : "---",
          },
        ];
        setOverviewHeaderFields(res);
      })
      .catch(() => {});
    getScopeItemsRequest({
      parent: "Scope",
      page: pageNum,
      size: perPageItems,
    });
  }, []);

  const fetchTaskData = async () => {
    scopeService
      .getTaskDetails({ id: notification.id })
      .then((taskData) => {
        setName(taskData.name);
        setTaskProgress(taskData.progress);
        if (taskData.assignments) {
          const newArray = taskData.assignments.map((obj) => ({
            value: obj.resource.id,
            label: obj.resource.name,
            image: obj.resource.image,
            capacity: obj.estimatedEffort,
          }));
          setAssignedResources(newArray);
        } else {
          setAssignedResources([]);
        }
        setStartDate(taskData.startDate);
        setEndDate(taskData.endDate);
        setCompletionDate(taskData.completionDate);
        setHours(taskData.estimatedEffort);
        setPriority(taskData.priority);
        setBudget(taskData.estimatedCost);
        setPhase(taskData.phase);
        setStatus(taskData.status);
        setRefId(taskData.refId);
        setDescription(taskData.description);
        setIsCritical(taskData.isCritical);
        setIsTaskMilestone(taskData.isMilestone);
        setTaskScope(taskData.scope ? { label: taskData.scope.name, value: taskData.scope.id }: null);
        setIsDraft(taskData.isDraft);
        setIsInWsr(taskData.isInWsr);
        setTaskDependencies(taskData?.dependencies);
        setRisks(taskData.risks);
        setAttachments(taskData.attachments || []);
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (allTasks) {
      setData(allTasks);
    }
  }, [allTasks]);

  useEffect(() => {
    if (notification.id) {
      fetchTaskData();
    } else {
      setName("");
      setTaskProgress(0);
      setStartDate("");
      setEndDate("");
      setCompletionDate("");
      setHours("");
      setStatus(0);
      setBudget("");
      setPhase("");
      setRefId("");
      setAssignedResources([]);
      setDescription("");
      setIsCritical(false);
      setIsTaskMilestone(false);
      setTaskScope(null);
      setIsDraft(false);
      setIsInWsr(false);
      setResources([]);
      setShowManagerDropdown(false);
      setResourceOptions([]);
      setPriority(0);
      setTask("");
      setTaskDependencies([]);
      setTaskDependenciesDto([]);
      setAllocations([]);
      setRisks([]);
      setAttachments([]);
    }
  }, [notification]);

  const handleSave = () => {
    const newAssignedResources = assignedResources.map((filteredResource) => ({
      ResourceId: filteredResource.value,
      EstimatedEffort: filteredResource.capacity,
    }));

    const mergedArray = newAssignedResources.map((item2) => {
      const matchedItem = allocations.find(
        (item1) => item1.resourceId === item2.ResourceId
      );
      if (matchedItem) {
        const { resourceId, ...allocationDetails } = matchedItem;
        return {
          ...item2,
          Allocations: allocationDetails.Allocations,
        };
      }
      return item2;
    });

    const payload = {
      ...(name && { Name: name }),
      ...(taskProgress && { Progress: taskProgress }),
      ...(refId && { RefId: refId }),
      ...(startDate && { startDate: startDate }),
      ...(endDate && { endDate: endDate }),
      ...(completionDate && { completionDate: completionDate }),
      ...(description && { Description: description }),
      ...(phase && { Phase: phase }),
      ...(status && { status: status }),
      ...(priority && { Priority: priority }),
      ...(isDraft && { isDraft: isDraft }),
      ...(isCritical && { isCritical: isCritical }),
      ...(isTaskMilestone && { isMilestone: isTaskMilestone }),
      ...(isInWsr && { isInWsr: isInWsr }),
      ...(id && { OwnerId: id }),
      ScopeId: scope ? scope?.value : scopeID,
      AssignedResources: mergedArray,
      ...({ Dependencies: taskDependenciesDto }),
    };

    const errors = {};
    if (!name) errors["name"] = `The Name field is required.`;
    if (startDate && endDate && isDateGreaterThan(startDate, endDate)) {
      errors[
        "endDate"
      ] = `End date must be equal to or greater than start date.`;
    }
    setFormErrors(errors);
    if (Object.keys(errors).length) {
      return;
    }

    updateTaskRequest({ id: scopeID, tId: notification.id, payload });
  };

  useEffect(() => {
    if (name) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        name: "",
      }));
    }
  }, [name]);

  const handleCancel = () => {
    setFormErrors({});
    setIsDraft(false);
    setIsCritical(false);
    setIsTaskMilestone(false);
    setIsInWsr(false);
    setTaskScope(null);
    setIsEdit(false);
    setIsCreate(false);
    setSelectedResources([]);
    setAssignedResources([]);
    setIsResolveConflict(false);
    setTotalCapacity(0);
    setTotalBudget(0);
    setTask("");
    setTaskDependencies([]);
    setTaskDependenciesDto([]);
    setAllocations([]);
    setAttachments([]);
    setIsModalOpen(false);
  };

  const searchHandler = (value) => {
    // if (value) {
    service
      .searchUsersForTastRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
          image: obj.image,
          availableCapacity: obj.availableCapacity,
          hourlyRate: obj.hourlyRate,
        }));
        setResourceOptions(transformedArray);
      })
      .catch(() => {});
    // }
  };

  const searchScopeHandler = (value) => {
    // if (value) {
    const payload = {
      projectId: project.id,
      value,
    };
    scopeService
      .searchScopeRequest(payload)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setScopes(transformedArray);
      })
      .catch(() => {});
    // }
  };

  const handleAssigneResource = (resource) => {
    setAssignedResources((prevSelectedResource) => {
      if (prevSelectedResource.some((res) => res.value === resource.value)) {
        return prevSelectedResource.filter(
          (res) => res.value !== resource.value
        );
      } else {
        return [...prevSelectedResource, { name: resource }];
      }
    });
    setSelectedResources((prevSelectedResource) => {
      if (prevSelectedResource.some((res) => res.value === resource.value)) {
        return prevSelectedResource.filter(
          (res) => res.value !== resource.value
        );
      } else {
        return [...prevSelectedResource, { name: resource }];
      }
    });
  };

  const handleInputChange = (id, capacity, rate) => {
    setSelectedResources((prevState) =>
      prevState.map((resource) =>
        resource.value === id
          ? { ...resource, capacity: capacity, hourlyRate: rate }
          : resource
      )
    );
  };

  const handleActiveChange = (id, isActive) => {
    const alreadyExist = selectedResources.filter((r) => r.value === id);
    if (alreadyExist.length === 0) {
      setSelectedResources((prevState) => {
        if (isActive) {
          const newResource = resourceOptions.find(
            (resource) => resource.value === id
          );
          return [...prevState, { ...newResource, inputValue: "" }];
        } else {
          return prevState.filter((resource) => resource.value !== id);
        }
      });
    }
  };

  const handleConfirm = () => {
    const newAssignedResources = [
      ...assignedResources,
      ...selectedResources.filter(
        (selectedResource) =>
          !assignedResources.some(
            (assignedResource) =>
              assignedResource.value === selectedResource.value
          )
      ),
    ];
    setAssignedResources(newAssignedResources);
    setIsPopoverOpen(false);
    setIsPopoverOpen2(false);
  };

  const handleCancelResource = () => {
    // setAssignedResources([]);
    setIsPopoverOpen(false);
    setIsPopoverOpen2(false);
  };

  const handleResolveConflicts = () => {
    setIsResolveConflict(true);
    const newAssignedResources = assignedResources.map((filteredResource) => ({
      ResourceId: filteredResource.value,
      EstimatedEffort: filteredResource.capacity,
    }));

    resourcesShiftsRequest({
      Resources: newAssignedResources,
    });

    localStorage.removeItem("allocations");
  };

  useEffect(() => {
    const newAssignedResources = assignedResources.map((filteredResource) => ({
      ResourceId: filteredResource.value,
      EstimatedEffort: filteredResource.capacity,
    }));

    if (dateRange) {
      resourcesShiftsRequest({
        StartDate: dateRange.startDate,
        EndDate: dateRange.endDate,
        Resources: newAssignedResources,
      });
    } else {
      resourcesShiftsRequest({
        Resources: newAssignedResources,
      });
    }
  }, [dateRange]);

  const updateCapacity = (array1, arr2) => {
    const updatedArray1 = array1.map((item1) => {
      const matchedItem = arr2.find(
        (item2) => item2.resourceId === item1.value
      );
      if (matchedItem) {
        const totalEffort = matchedItem.Allocations.reduce(
          (sum, allocation) => sum + allocation.Effort,
          0
        );
        return {
          ...item1,
          approvedCapacity: totalEffort,
        };
      }
      return item1;
    });

    return updatedArray1;
  };

  const updateResourceCapacity = (e) => {
    const index = assignedResources.findIndex((r) => r.value === e.value);
    if (index !== -1) {
      const updatedResources = [
        ...assignedResources.slice(0, index),
        e,
        ...assignedResources.slice(index + 1),
      ];
      setAssignedResources(updatedResources);

      const newAssignedResources = assignedResources.map(
        (filteredResource) => ({
          ResourceId: filteredResource.value,
          EstimatedEffort: filteredResource.capacity,
        })
      );

      resourcesShiftsRequest({
        Resources: newAssignedResources,
      });
    }
  };

  const formBody = () => {
    let updatedArray1 = [];
    if (allocations.length > 0) {
      updatedArray1 = updateCapacity(assignedResources, allocations);
    }
    return (
      <>
      <div className="d-flex align-items-end justify-content-between">
          <div className="col-10">
            <InputUnderline
              placeholder="Add task name"
              isRequired
              value={name}
              error={formErrors.name}
              handleChange={setName}
            />
          </div>
          <div className="w-20 ml-2">
            <Input
              icon="%"
              placeholder="0"
              max={100}
              value={taskProgress}
              type="number"
              handleChange={setTaskProgress}
              label="Progress"
            />
          </div>
        </div>
        <div className="flex col-10 gap-3 mt-3">
            <ModalCheckboxWarning
              label={isCritical ? "Critical" : "Mark as Critical"}
              checked={isCritical}
              setChecked={setIsCritical}
          />
            <ModalCheckbox
              label={isTaskMilestone ? "Milestone" : "Mark as Milestone"}
              checked={isTaskMilestone}
              setChecked={setIsTaskMilestone}
            />
            <ModalCheckbox
              label={isInWsr ? "In WSR" : "Include in WSR"}
              checked={isInWsr}
              setChecked={setIsInWsr}
            />
        </div>

        <TaskDependencies 
          projectId={project?.id} 
          scope={taskScope}
          taskDependencies={taskDependencies} 
          onDependenciesChange={setTaskDependenciesDto}/>

        <AssociatedRisks risks={risks}/>

        <div
          className={`TaskResBox mt-4 mb-3 ${
            assignedResources.length > 0
              ? "ResolveConfWrapper"
              : "selectResource"
          }`}
        >
          <div className="d-flex flex-wrap gap-2">
            <TeachingPopover
              positioning="below-start"
              withArrow={false}
              open={isPopoverOpen}
              onOpenChange={(event, data) => setIsPopoverOpen(data.open)}
            >
              <TeachingPopoverTrigger>
                <div
                  className="assignToItems"
                  onClick={() => {
                    setResourceOptions([]);
                  }}
                >
                  <Button className="assignAvatarBtn">
                    <Avatar icon={<AddPersonIcon />} name="" />
                  </Button>
                  <p className="text-xsm-400 ms-1">Assign resource</p>
                </div>
              </TeachingPopoverTrigger>
              <TeachingPopoverSurface className="addCapacitySurface">
                <TeachingPopoverHeader
                  className="addCapacityHeader"
                  icon={false}
                >
                  Resources
                </TeachingPopoverHeader>
                <TeachingPopoverBody className="addCapacityBody">
                  <Input placeholder="Search" handleChange={searchHandler} />
                  <div className="mt-2 AddCapacityWrapper">
                    {resourceOptions.map((resource) => (
                      <AddCapacity
                        item={resource}
                        previousOptions={selectedResources}
                        onInputChange={handleInputChange}
                        onActiveChange={handleActiveChange}
                      />
                    ))}
                  </div>
                </TeachingPopoverBody>
                <div className="addCapacityFooter">
                  <CustomButton
                    btnClass="d_btn d_btn_smallWhite me-10"
                    label="Cancel"
                    clickHandler={handleCancelResource}
                  />
                  <CustomButton
                    btnClass="d_btn d_btn_primary"
                    label="Confirm"
                    clickHandler={handleConfirm}
                  />
                </div>
              </TeachingPopoverSurface>
            </TeachingPopover>

            {updatedArray1.length > 0 ? (
              updatedArray1.map((res) => (
                <HourlyEstimation
                  item={res}
                  updateResourceCapacity={updateResourceCapacity}
                  TriggerBtn={
                    <div
                      className={`assignToItems ${
                        res.approvedCapacity > res.capacity
                          ? "conflictItem"
                          : ""
                      } `}
                    >
                      <Avatar
                        color="colorful"
                        name={res.label}
                        image={{ src: res.image }}
                      />
                      <div>
                        <p className="text-xsm-400">{res.label}</p>
                        <span className="text-xsm-400">
                          {res.capacity
                            ? `${
                                res?.approvedCapacity
                                  ? res?.approvedCapacity + "hrs"
                                  : 0
                              }/${res.capacity}hrs`
                            : ""}
                        </span>
                      </div>
                      <div onClick={() => handleAssigneResource(res)}>
                        <FilterCross />
                      </div>
                    </div>
                  }
                />
              ))
            ) : (
              <>
                {assignedResources.map((res) => (
                  <HourlyEstimation
                    item={res}
                    updateResourceCapacity={updateResourceCapacity}
                    TriggerBtn={
                      <div className="assignToItems">
                        <Avatar
                          color="colorful"
                          name={res.label}
                          image={{ src: res.image }}
                        />
                        <div>
                          <p className="text-xsm-400">{res.label}</p>
                          <span className="text-xsm-400">
                            {res.capacity ? `${res.capacity}hrs` : ""}
                          </span>
                        </div>
                        <div onClick={() => handleAssigneResource(res)}>
                          <FilterCross />
                        </div>
                      </div>
                    }
                  />
                ))}
              </>
            )}
          </div>
          {/* {!isResolveConflict && <CustomButton icon={<CalendarWorkWeek />} btnClass="d_btn d_btn_whiteXsm text-nowrap ResolveConfBtn" label="Manage Allocation" clickHandler={handleResolveConflicts} />} */}
        </div>
        {/* {isResolveConflict ? conflictModalBody() : largeModalBody()} */}
        {largeModalBody()}
        <RichTextEditor
          wrapperClass="mb-3"
          label="Description"
          content={description}
          onChange={setDescription}
        />
        <EntityFileUpload
          entityId={notification?.id}
          entityType="Task"
          attachments={attachments}
          onAttachmentsChange={() => {
            if (notification?.id) {
              scopeService
                .getTaskAttachements({ id: notification.id })
                .then((attachements) => {
                  setAttachments(attachements || []);
                })
                .catch(() => {});
            }
          }}
          disabled={!notification?.id}
        />
      </>
    );
  };

  const largeModalBody = () => (
    <>
      <div className="row align-items-center gx-3 mb-3">
        <DateRangeWithDuration
          startDate={startDate}
          endDate={endDate}
          onStartDateChange={setStartDate}
          onEndDateChange={setEndDate}
          startDateError={formErrors.startDate}
          endDateError={formErrors.endDate}
          isStartDateDisabled={Number(taskProgress) > 0}
          icon={<CalendarIcon />}
        />
        <div className="col-4">
          <Input
            icon={<CalendarIcon />}
            value={completionDate}
            minDate={endDate || startDate}
            type="date"
            handleChange={setCompletionDate}
            label="Completion Date"
            errorMessage={formErrors.completionDate}
          />
        </div>
      </div>
      <div className="row align-items-center gx-3 mb-3">
        <div className="col-4">
          <Input
            icon={`${totalCapacity}hrs`}
            placeholder="0 hrs"
            value={hours}
            type="text"
            handleChange={setHours}
            label="Estimated/Assigned Hours"
            InputIconProp="text-xsm-700 calanderHeadercolor"
            // errorMessage={formErrors.endDate}
          />
        </div>
        <div className="col-4">
          <Input
            icon={`$${totalBudget}`}
            placeholder={`${getAccountCurrency(setting)} 0`}
            value={budget}
            type="number"
            handleChange={setBudget}
            InputIconProp="text-xsm-700 calanderHeadercolor"
            label="Estimated/Allocated Budget"
          />
        </div>
        <div className="col-4">
          <DropDown
            label="Priority"
            options={taskPriorityOptions}
            defaultVal={getLabelByType("taskPriority", priority)}
            onChange={setPriority}
          />
        </div>
      </div>
      <div className="row align-items-center gx-3 mb-3">
        <div className="col-4">
          <DropDown
            label="Status"
            options={taskStatusOptions}
            defaultVal={getLabelByType("taskStatus", status)}
            onChange={setStatus}
          />
        </div>
        <div className="col-4">
          <Input
            icon={false}
            placeholder="Enter phase"
            value={phase}
            type="text"
            handleChange={setPhase}
            label="Phase"
          />
        </div>
        <div className="col-4">
          <Searchable
            label="Scopes"
            SelectText="Scopes"
            selectWd="me-3"
            persona={true}
            searchText={searchScopeHandler}
            options={scopes}
            defaultVal={currentScope}
            onChange={(e) => setScope(e)}
          />
        </div>
      </div>
      <div className="row align-items-center gx-3 mb-3">
        <div className="col-4">
          <Input
            icon={false}
            placeholder="Enter Change Ticket"
            value={refId}
            type="text"
            handleChange={setRefId}
            label="Change Ticket"
          />
        </div>
      </div>
    </>
  );

  useEffect(() => {
    if (assignedResources.length > 0) {
      const resourcesCapacities = assignedResources.filter((obj) =>
        obj.hasOwnProperty("capacity")
      );
      const resourcesBudgets = assignedResources.filter((obj) =>
        obj.hasOwnProperty("hourlyRate")
      );

      const budget = resourcesBudgets.reduce((sum, obj) => {
        return sum + parseFloat(obj.hourlyRate);
      }, 0);

      const capacity = resourcesCapacities.reduce((sum, obj) => {
        return sum + parseFloat(obj.capacity);
      }, 0);

      setTotalBudget(budget);
      setTotalCapacity(capacity);
    }
  }, [assignedResources]);

  useEffect(() => {
    if (startDate && endDate && isDateGreaterThan(startDate, endDate)) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        endDate: `End date must be equal to or greater than start date.`,
      }));
    } else {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        endDate: "",
      }));
    }
  }, [endDate]);

  useEffect(() => {
    if (
      startDate &&
      completionDate &&
      isDateGreaterThan(startDate, completionDate)
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        completionDate: `Completion date must be greater than start date.`,
      }));
    } else {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        completionDate: "",
      }));
    }
  }, [completionDate]);

  return (
    <>
      <Modal
        title="Task"
        handleCancel={handleCancel}
        handleSave={handleSave}
        body={formBody()}
        isLoading={loader}
        size="large"
        saveBtnLabel="Save"
        cancelBtnLabel="Cancel"
      />
    </>
  );
};

const ChangeRequest = (props) => {
  const {
    projectID,
    programID,
    loader,
    updateChangeRequest,
    setIsModalOpen,
    notification,
  } = props;
  const date = new Date();
  const history = useHistory();
  const settings = JSON.parse(localStorage.getItem("settings"));
  const user = JSON.parse(localStorage.getItem("user"));
  const [setting] = useState(settings);
  const [selectedRow, setSelectedRow] = useState({});
  const [Name, setName] = useState("");
  const [Description, setDescription] = useState("");
  const [Type, setType] = useState("");
  const [Status, setStatus] = useState("");
  const [Priority, setPriority] = useState("");
  const [Budget, setBudget] = useState("");
  const [ApprovedBudget, setApprovedBudget] = useState("");
  const [RevisedApprovedBudget, setRevisedApprovedBudget] = useState("");
  const [ETC, setETC] = useState("");
  const [ETT, setETT] = useState("");
  const [PendingRFC, setPendingRFC] = useState("");
  const [ApprovedRFC, setApprovedRFC] = useState("");
  const [Requester, setRequester] = useState("");
  const [AffectedWorkstream, setAffectedWorkstream] = useState("");
  const [HardwareSoftwareCost, setHardwareSoftwareCost] = useState("");
  const [AdditionalMaterials, setAdditionalMaterials] = useState("");
  const [risks, setRisks] = useState([]);
  const [owner, setOwner] = useState({});
  const [OwnerId, setOwnerId] = useState(user && user.id);
  const [ProjectId, setProjectId] = useState(projectID);
  const [projectOptions, setProjectOptions] = useState([]);
  const [checkedAddRisk, setCheckedAddRisk] = useState(false);
  const [assignedManager, setAssignedManager] = useState({});
  const [riskTitle, setRiskTitle] = useState("");
  const [riskType, setRiskType] = useState("");
  const [riskStatus, setRiskStatus] = useState("");
  const [dateIdentified, setDateIdentified] = useState("");
  const [dateImpact, setDateImpact] = useState("");
  const [probability, setProbability] = useState("");
  const [impact, setImpact] = useState("");
  const [managers, setManagers] = useState([]);
  const [parentType, setParentType] = useState("Change Request");
  const [formErrors, setFormErrors] = useState({
    name: "",
    projectId: "",
  });

  const setRiskStatusType = (type) => {
    switch (type) {
      case "Identified":
        return 0;
      case "Accessed":
        return 1;
      case "Prioritized":
        return 2;
      case "Mitigated":
        return 3;
      case "Monitored":
        return 4;
      case "Active":
        return 5;
      case "Closed":
        return 6;
      case "Contingent":
        return 7;
      case "Accepted":
        return 8;
      case "Escalated":
        return 9;
      default:
        return 0;
    }
  };

  const setRequestType = (type) => {
    switch (type) {
      case "Scope":
        return 0;
      case "Schedule":
        return 1;
      case "Budget":
        return 2;
      case "Quality":
        return 3;
      case "Resource":
        return 4;
      default:
        return 0;
    }
  };

  const setRequestStatus = (type) => {
    switch (type) {
      case "Pending":
        return 1;
      case "Approved":
        return 2;
      case "Rejected":
        return 3;
      case "Deferred":
        return 4;
      case "Executing":
        return 5;
      case "Implemented":
        return 6;
      case "Withdraw":
        return 7;
      default:
        return 0;
    }
  };

  const setRequestPriority = (type) => {
    switch (type) {
      case "Moderate":
        return 1;
      case "High":
        return 2;
      default:
        return 0;
    }
  };

  const getRequestType = (type) => {
    switch (type) {
      case 1:
        return "Schedule";
      case 2:
        return "Budget";
      case 3:
        return "Quality";
      case 4:
        return "Resource";
      default:
        return "Scope";
    }
  };

  const getRequestStatus = (type) => {
    switch (type) {
      case 1:
        return "Pending";
      case 2:
        return "Approved";
      case 3:
        return "Rejected";
      case 4:
        return "Deferred";
      case 5:
        return "Executing";
      case 6:
        return "Implemented";
      case 7:
        return "Withdraw";
      default:
        return "Initiating";
    }
  };

  const getRequestPriority = (type) => {
    switch (type) {
      case 1:
        return "Moderate";
      case 2:
        return "High";
      default:
        return "Low";
    }
  };

  const handleSave = () => {
    const errors = {};
    if (!Name) errors["name"] = `The Name field is required.`;
    if (!projectID) {
      if (!ProjectId) errors["projectId"] = `The Project field is required.`;
    }
    setFormErrors(errors);
    if (Object.keys(errors).length) {
      return;
    }
    const payload = {
      Name,
      Type: setRequestType(Type),
      Status: setRequestStatus(Status),
      Priority: setRequestPriority(Priority),
      Budget: parseInt(Budget) || 0,
      ApprovedBudget: parseInt(ApprovedBudget) || 0,
      RevisedApprovedBudget: parseInt(RevisedApprovedBudget) || 0,
      HardwareSoftwareCost: parseInt(HardwareSoftwareCost) || 0,
      ETC: parseInt(ETC) || 0,
      PendingRFC: parseInt(PendingRFC) || 0,
      ApprovedRFC: parseInt(ApprovedRFC) || 0,
      Requester,
      AffectedWorkstream,
      ETT: parseInt(ETT) || 0,
      Description,
      AdditionalMaterials,
      OwnerId: assignedManager && assignedManager.value,
      ProjectId: parentType === "Change Request" ? ProjectId.value : projectID,
      // ProjectId: projectID ? ProjectId : ProjectId.value,
    };
    const risk = {
      Name: riskTitle,
      Type: setRequestType(riskType) || 0,
      Status: setRiskStatusType(riskStatus) || 0,
      DateIdentified: dateIdentified || dateOnlyFormatted(setting, date),
      DateTmpact: dateImpact,
      Probability: probability || 0,
      Impact: impact || 0,
      OwnerId: OwnerId,
      ChangeRequestId: selectedRow.id,
      ProjectId: ProjectId,
    };
    if (checkedAddRisk) payload.Risk = risk;
    updateChangeRequest({
      id: notification.id,
      parent: "Change Request",
      payload,
    });

    setRiskTitle("");
    setRiskType("");
    setRiskStatus("");
    setDateIdentified("");
    setDateImpact("");
    setProbability("");
    setImpact("");
  };

  const handleCancel = () => {
    setFormErrors({});
    setOwner({});
    setCheckedAddRisk(false);
    setRiskTitle("");
    setIsModalOpen(false);
  };

  const handleInputChange = (value, name) => {
    if (name === "name") setName(value);
  };

  const fetchChangeRequestData = async () => {
    service
      .fetchSingleChangeRequest(notification.id)
      .then((requestData) => {
        setName(requestData.name);
        setType(getRequestType(requestData.type));
        setStatus(getRequestStatus(requestData.status));
        setPriority(getRequestPriority(requestData.priority));
        setBudget(`${requestData.budget}`);
        setApprovedBudget(`${requestData.approvedBudget}`);
        setRevisedApprovedBudget(`${requestData.revisedApprovedBudget}`);
        setHardwareSoftwareCost(`${requestData.hardwareSoftwareCost}`);
        setETC(`${requestData.etc}`);
        setPendingRFC(`${requestData.pendingRFC}`);
        setApprovedRFC(`${requestData.approvedRFC}`);
        setRequester(`${requestData.requester}`);
        setAffectedWorkstream(`${requestData.affectedWorkstream}`);
        setETT(`${requestData.ett}`);
        setDescription(requestData.description);
        setAdditionalMaterials(`${requestData.additionalMaterials}`);
        setRisks(requestData.risks);
        if (requestData.project) {
          setProjectId({
            label: requestData.project.name,
            value: requestData.project.id,
          });
        }
        if (requestData.owner) {
          setAssignedManager({
            label: requestData.owner.name,
            value: requestData.owner.id,
            image: requestData.owner.image,
          });
        }
        setOwnerId(`${requestData.owner.id}`);
        setOwner(requestData.owner);
      })
      .catch((error) => console.error("Error fetching user data:", error));
  };

  useEffect(() => {
    if (notification.id) {
      fetchChangeRequestData();
      setCheckedAddRisk(false);
      setRiskTitle("");
    } else {
      setName("");
      setType("");
      setStatus("");
      setPriority("");
      setBudget("");
      setApprovedBudget("");
      setRevisedApprovedBudget("");
      setHardwareSoftwareCost("");
      setETC("");
      setPendingRFC("");
      setApprovedRFC("");
      setRequester("");
      setAffectedWorkstream("");
      setETT("");
      setDescription("");
      setAdditionalMaterials("");
      setRisks([]);
      setOwner({});
      setProjectId("");
    }
  }, [notification]);

  useEffect(() => {
    if (Name) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        name: "",
      }));
    }
    if (ProjectId) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        projectId: "",
      }));
    }
  }, [ProjectId, Name]);

  const searchHandler = (value) => {
    if (value === "") {
      setManagers([]);
      return;
    }
    // if (value) {
    userService.searchUserDataRequest(value).then((res) => {
      if (res.status === 401) {
        localStorage.clear();
        history.push("/");
      }

      const transformedArray =
        res &&
        res.map((obj) => ({
          label: obj.name,
          value: obj.id,
          image: obj.profilePictureUrl,
        }));
      setManagers(transformedArray);
    });
    // }
  };

  const searchProjectHandler = (value) => {
    if (value === "") {
      setProjectOptions([]);
      return;
    }
    // if (value) {
    const payload = {
      searchText: value,
    };
    payload.parent = "Change Request";
    if (programID) {
      payload.id = programID;
      payload.parent = "Program";
    }
    if (projectID) {
      payload.id = projectID;
      payload.parent = "Project";
    }

    projectService.searchProjectsRequest(payload).then((res) => {
      const transformedArray = res.map((obj) => ({
        label: obj.name,
        value: obj.id,
      }));
      setProjectOptions(transformedArray);
    });
    // } else {
    //     setProjectOptions([]);
    // }
  };

  const formBody = () => {
    return (
      <>
        <InputUnderline
          placeholder="Add change request title"
          isRequired
          value={Name}
          error={formErrors.name}
          handleChange={(value) => handleInputChange(value, "name")}
        />
        {Object.keys(selectedRow).length > 0 && <AssociatedRisks risks={risks}/>}
        <div className="ModalAvatarGroup">
          <div className="row align-items-end gx-3">
            <div className="col-4">
              <Searchable
                CustomClass="ModalAvatarSearch"
                label="Manager"
                SelectText="resources"
                persona={true}
                searchText={searchHandler}
                options={managers}
                defaultVal={assignedManager}
                onChange={setAssignedManager}
                creatable={true}
                setCreated={setManagers}
              />
            </div>
            {Object.keys(owner).length > 0 && (
              <div className="col-8">
                <div className="AvatarGroupWrapper">
                  <Avatar
                    size={28}
                    color="colorful"
                    name={owner.name}
                    image={{ src: owner.image }}
                  />
                </div>
              </div>
            )}
          </div>
          {!projectID && (
            <div className="row align-items-end gx-3">
              <div className="col-4">
                <Searchable
                  label="Project"
                  SelectText="project"
                  isRequired
                  searchText={searchProjectHandler}
                  options={projectOptions}
                  defaultVal={ProjectId}
                  onChange={(e) => setProjectId(e)}
                  errorMessage={formErrors.projectId}
                />
              </div>
            </div>
          )}
        </div>
        <div>
          <div className="row align-items-center mb-3 gx-3">
            <div className="col-4">
              <DropDown
                label="Type"
                options={changeRequestTypes}
                defaultVal={Type}
                onChange={setType}
              />
            </div>
            <div className="col-4">
              <DropDown
                label="Priority"
                options={changeRequestPriorities}
                defaultVal={Priority}
                onChange={setPriority}
              />
            </div>
            <div className="col-4">
              <DropDown
                label="Status"
                options={changeRequestStatus}
                defaultVal={Status}
                onChange={setStatus}
              />
            </div>
          </div>
          <div className="row align-items-center gx-3 mb-3">
            <div className="col-4">
              <Input
                value={`${Budget}`}
                handleChange={setBudget}
                label="Budget"
                placeholder="0"
                type="number"
                currency={true}
              />
            </div>
            <div className="col-4">
              <Input
                value={`${ApprovedBudget}`}
                handleChange={setApprovedBudget}
                label="Approved Budget"
                placeholder="0"
                type="number"
                currency={true}
              />
            </div>
            <div className="col-4">
              <Input
                value={`${RevisedApprovedBudget}`}
                handleChange={setRevisedApprovedBudget}
                label="Revised Approved Budget"
                placeholder="0"
                type="number"
                currency={true}
              />
            </div>
          </div>
          <div className="row align-items-center gx-3 mb-3">
            <div className="col-4">
              <Input
                value={`${HardwareSoftwareCost}`}
                handleChange={setHardwareSoftwareCost}
                label="Hardware / Software Cost"
                placeholder="0"
                type="number"
                currency={true}
              />
            </div>
            <div className="col-4">
              <Input
                value={`${ETC}`}
                handleChange={setETC}
                label="ETC"
                placeholder="0"
                type="number"
                currency={true}
              />
            </div>
            <div className="col-4">
              <Input
                value={`${PendingRFC}`}
                handleChange={setPendingRFC}
                label="Pending RFC"
                placeholder="0"
                type="number"
                currency={true}
              />
            </div>
          </div>
          <div className="row align-items-center gx-3 mb-3">
            <div className="col-4">
              <Input
                value={`${ApprovedRFC}`}
                handleChange={setApprovedRFC}
                label="Approved RFC"
                placeholder="0"
                type="number"
                currency={true}
              />
            </div>
            <div className="col-4">
              <Input
                value={`${Requester}`}
                type="text"
                handleChange={setRequester}
                label="Requester"
                placeholder="--"
              />
            </div>
            <div className="col-4">
              <Input
                value={`${AffectedWorkstream}`}
                type="text"
                handleChange={setAffectedWorkstream}
                label="Affected Workstream"
                placeholder="--"
              />
            </div>
          </div>
          <div className="row justify-content-start align-items-center gx-3 mb-3">
            <div className="col-4">
              <Input
                value={`${ETT}`}
                type="number"
                handleChange={setETT}
                label="ETA (hr)"
                placeholder="Hrs"
              />
            </div>
          </div>
          <div className="mb-3">
            <RichTextEditor
              label="Description"
              content={Description}
              onChange={setDescription}
            />
          </div>
          <div>
            <RichTextEditor
              label="Additional Materials"
              content={AdditionalMaterials}
              onChange={setAdditionalMaterials}
            />
          </div>
          <>
            {Object.keys(selectedRow).length > 0 && (
              <div className="d-flex justify-content-between align-items-center mt-4">
                <CheckboxInput
                  label="Add risk"
                  checked={checkedAddRisk}
                  setChecked={() => setCheckedAddRisk(!checkedAddRisk)}
                />
              </div>
            )}
            {checkedAddRisk && (
              <>
                <div className="row align-items-center mb-3 gx-3">
                  <div className="col-4">
                    <Input
                      value={`${riskTitle}`}
                      type="text"
                      handleChange={setRiskTitle}
                      label="Title"
                      placeholder="Enter Title"
                    />
                  </div>
                  <div className="col-4">
                    <DropDown
                      label="Type"
                      options={changeRequestTypes}
                      defaultVal={riskType}
                      onChange={setRiskType}
                    />
                  </div>
                  <div className="col-4">
                    <DropDown
                      label="Status"
                      options={riskStatusOptions}
                      defaultVal={riskStatus}
                      onChange={setRiskStatus}
                    />
                  </div>
                </div>
                <div className="row align-items-center mb-3 gx-3">
                  <div className="col-4">
                    <Input
                      value={dateIdentified}
                      type="date"
                      handleChange={setDateIdentified}
                      label="Date Identified"
                      placeholder="Enter Date"
                    />
                  </div>
                  <div className="col-4">
                    <Input
                      value={`${dateImpact}`}
                      type="date"
                      handleChange={setDateImpact}
                      label="Impact Date"
                      placeholder="Enter Date"
                    />
                  </div>
                  <div className="col-4">
                    <DropDown
                      label="Probability"
                      options={riskProbability}
                      defaultVal={probability}
                      onChange={setProbability}
                    />
                  </div>
                </div>
                <div className="row align-items-center mb-3 gx-3">
                  <div className="col-4">
                    <DropDown
                      label="Impact"
                      options={riskImpact}
                      defaultVal={impact}
                      onChange={setImpact}
                    />
                  </div>
                </div>
              </>
            )}
          </>
        </div>
      </>
    );
  };

  return (
    <Modal
      title="Change request"
      handleCancel={handleCancel}
      handleSave={handleSave}
      body={formBody()}
      isLoading={loader}
      size="large"
      saveBtnLabel="Save"
      cancelBtnLabel="Cancel"
    />
  );
};

const Risk = (props) => {
  const {
    projectID,
    programID,
    updateRiskRequest,
    setIsModalOpen,
    notification,
    loader,
  } = props;
  const [ProjectId, setProjectId] = useState(projectID);
  const [projectOptions, setProjectOptions] = useState([]);
  const [name, setName] = useState("");
  const [isIssue, setIsIssue] = useState(false);
  const [dateIdentified, setDateIdentified] = useState("");
  const [dateResolved, setDateResolved] = useState("");
  const [dateImpact, setDateImpact] = useState("");
  const [type, setType] = useState("");
  const [changeRequests, setChangeRequests] = useState([]);
  const [changeRequest, setChangeRequest] = useState("");
  const [manager, setManager] = useState(null);
  const [managerOptions, setManagerOptions] = useState([]);
  const [prime, setPrime] = useState("");
  const [status, setStatus] = useState("");
  const [probability, setProbability] = useState("");
  const [impact, setImpact] = useState("");
  const [description, setDescription] = useState("");
  const [formErrors, setFormErrors] = useState({
    name: "",
    projectId: "",
  });

  const setRequestType = (type) => {
    switch (type) {
      case "Schedule":
        return 1;
      case "Budget":
        return 2;
      case "Quality":
        return 3;
      case "Resource":
        return 4;
      default:
        return 0;
    }
  };

  const setRequestStatus = (type) => {
    switch (type) {
      case "Pending":
        return 1;
      case "Approved":
        return 2;
      case "Rejected":
        return 3;
      case "Deferred":
        return 4;
      case "Executing":
        return 5;
      case "Implemented":
        return 6;
      case "Withdraw":
        return 7;
      default:
        return 0;
    }
  };

  const getRequestType = (type) => {
    switch (type) {
      case 1:
        return "Schedule";
      case 2:
        return "Budget";
      case 3:
        return "Quality";
      case 4:
        return "Resource";
      default:
        return "Scope";
    }
  };

  const getRequestStatus = (type) => {
    switch (type) {
      case 1:
        return "Pending";
      case 2:
        return "Approved";
      case 3:
        return "Rejected";
      case 4:
        return "Deferred";
      case 5:
        return "Executing";
      case 6:
        return "Implemented";
      case 7:
        return "Withdraw";
      default:
        return "Initiating";
    }
  };

  const handleCancel = () => {
    setFormErrors({});
    setIsModalOpen(false);
  };

  const handleInputChange = (value, name) => {
    if (name === "name") {
      setName(value);
      if (formErrors && value) {
        setFormErrors({
          ...formErrors,
          [name]: "",
        });
      }
    }
  };

  const handleSave = () => {
    const errors = {};
    if (!name) errors["name"] = `The Name field is required.`;
    if (!projectID) {
      if (!ProjectId) errors["projectId"] = `The Project field is required.`;
    }
    setFormErrors(errors);
    if (Object.keys(errors).length) {
      return;
    }
    const payload = {
      Name: name,
      isIssue: isIssue,
      DateIdentified: dateIdentified ? dateIdentified : new Date(),
      DateTmpact: dateImpact,
      DateResolved: dateResolved,
      Type: setRequestType(type),
      ChangeRequestId: changeRequest && changeRequest.value,
      OwnerId: manager ? manager.value : null,
      Status: setRequestStatus(status),
      Probability: probability ? probability : 0,
      Impact: impact ? impact : 0,
      Description: description,
      Prime: prime,
      ProjectId: projectID ? ProjectId : ProjectId.value,
    };

    updateRiskRequest({
      id: projectID,
      parentID: projectID,
      parent: "Risk",
      payload: { rId: notification.id, payload },
    });
  };

  const fetchRiskData = async () => {
    riskService
      .getRiskDetailsRequest({ id: notification.id })
      .then((riskData) => {
        setName(riskData.name);
        if (riskData.isIssue) {
          setIsIssue(true);
        } else {
          setIsIssue(false);
        }
        setProjectId({
          label: riskData.project.name,
          value: riskData.project.id,
        });
        setDateIdentified(riskData.dateIdentified);
        setDateResolved(riskData.dateResolved);
        setDateImpact(riskData.dateImpact);
        setType(getRequestType(riskData.type));

        if (riskData.changeRequest) {
          const changeRequestArr = {
            value: riskData.changeRequest.id,
            label: riskData.changeRequest.name,
          };
          setChangeRequest(changeRequestArr);
        } else {
          setChangeRequest("");
        }
        if (riskData.owner) {
          const manArr = {
            value: riskData.owner.id,
            label: riskData.owner.name,
          };
          setManager(manArr);
        } else {
          setManager("");
        }
        setPrime(riskData.prime ? riskData.prime : "");
        setStatus(getRequestStatus(riskData.status));
        setProbability(riskData.probability);
        setImpact(riskData.impact);
        setDescription(riskData.description);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };

  useEffect(() => {
    if (notification.id) {
      fetchRiskData();
    } else {
      setName("");
      setIsIssue(false);
      setDateIdentified("");
      setDateResolved("");
      setDateImpact("");
      setType("");
      setChangeRequest("");
      setPrime("");
      setStatus("");
      setProbability("");
      setImpact("");
      setDescription("");
      setManager("");
      setChangeRequests([]);
      setManagerOptions([]);
      setFormErrors({});
    }
  }, [notification]);

  const searchManagerHandler = (value) => {
    if (value === "") {
      setManagerOptions([]);
      return;
    }
    // if (value) {
    userService
      .searchUserDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setManagerOptions(transformedArray);
      })
      .catch(() => {});
    // }
  };

  const searchChangRequestHandler = (value) => {
    if (value === "") {
      setChangeRequests([]);
      return;
    }
    // if (value) {
    riskService
      .searchChangeRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setChangeRequests(transformedArray);
      })
      .catch(() => {});
    // }
  };

  const searchProjectHandler = (value) => {
    if (value === "") {
      setProjectOptions([]);
      return;
    }
    // if (value) {
    const payload = {
      searchText: value,
    };
    payload.parent = "Risk";

    if (programID) {
      payload.id = programID;
      payload.parent = "Program";
    }
    if (projectID) {
      payload.id = projectID;
      payload.parent = "Project";
    }
    //   if(portfolioID) { payload.id = portfolioID; payload.parent = 'Portfolio'; }

    projectService.searchProjectsRequest(payload).then((res) => {
      const transformedArray = res.map((obj) => ({
        label: obj.name,
        value: obj.id,
      }));
      setProjectOptions(transformedArray);
    });
    // } else {
    //     setProjectOptions([]);
    // }
  };

  useEffect(() => {
    if (name) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        name: "",
      }));
    }
    if (ProjectId) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        projectId: "",
      }));
    }
  }, [ProjectId, name]);

  const formBody = () => {
    return (
      <>
        <InputUnderline
          placeholder="Add risk title"
          isRequired
          value={name}
          error={formErrors.name}
          handleChange={(value) => handleInputChange(value, "name")}
        />
        <div className="mt-4 mb-3">
          <div className="d-inline-block">
            <ModalCheckbox
              label="Mark as Issue"
              checked={isIssue}
              setChecked={setIsIssue}
            />
          </div>
        </div>
        {!projectID && (
          <div className="row align-items-end gx-3">
            <div className="col-4">
              <Searchable
                label="Project"
                SelectText="project"
                isRequired
                searchText={searchProjectHandler}
                options={projectOptions}
                defaultVal={ProjectId}
                onChange={(e) => setProjectId(e)}
                errorMessage={formErrors.projectId}
              />
            </div>
          </div>
        )}
        <div className="row align-items-center mb-3 gx-3">
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={dateIdentified ? dateIdentified : ""}
              type="date"
              handleChange={setDateIdentified}
              label="Date Identified"
              placeholder="Enter Date"
            />
          </div>
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={dateImpact ? dateImpact : ""}
              type="date"
              handleChange={setDateImpact}
              label="Date Of Impact"
              placeholder="Enter Date"
            />
          </div>
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={dateResolved ? dateResolved : ""}
              type="date"
              handleChange={setDateResolved}
              label="Date Resolved"
              placeholder="Enter Date"
            />
          </div>
          
        </div>
        <div className="row align-items-center mb-3 gx-3">
          <div className="col-4">
            <DropDown
              label="Type"
              options={changeRequestTypes}
              defaultVal={type}
              onChange={setType}
            />
          </div>
          <div className="col-4">
            {/* <DropDown label="Change Request" options={changeRequests} defaultVal={changeRequest} onChange={setChangeRequest} /> */}
            <Searchable
              label="Change Request"
              searchText={searchChangRequestHandler}
              SelectText="change request"
              options={changeRequests}
              defaultVal={changeRequest}
              onChange={setChangeRequest}
            />
          </div>
          <div className="col-4">
            <Searchable
              label="Prime"
              searchText={searchManagerHandler}
              options={managerOptions}
              SelectText="prime"
              defaultVal={manager}
              onChange={setManager}
            />
          </div>
        </div>
        <div className="row align-items-center mb-3 gx-3">
          <div className="col-4">
            <Input
              value={`${prime}`}
              type="text"
              handleChange={setPrime}
              label="Prime"
              placeholder="Enter Prime"
            />
          </div>
          <div className="col-4">
            <DropDown
              label="Status"
              options={riskStatus}
              defaultVal={dateResolved ? "Closed" : status}
              onChange={setStatus}
              disabled={dateResolved}
            />
          </div>
          <div className="col-4">
            <DropDown
              label="Probability"
              options={riskProbability}
              defaultVal={probability}
              onChange={setProbability}
            />
          </div>
        </div>
        <div className="row align-items-center mb-3 gx-3">
          <div className="col-4">
            <DropDown
              label="Impact"
              options={riskImpact}
              defaultVal={impact}
              onChange={setImpact}
            />
          </div>
        </div>
        <div className="mb-3">
          <RichTextEditor
            label="Description"
            content={description}
            onChange={setDescription}
          />
        </div>
      </>
    );
  };

  return (
    <>
      <Modal
        title="Risk"
        handleCancel={handleCancel}
        handleSave={handleSave}
        body={formBody()}
        isLoading={loader}
        size="large"
        saveBtnLabel="Save"
        cancelBtnLabel="Cancel"
      />
    </>
  );
};

const Budget = (props) => {
  const {
    portfolioID,
    programID,
    projectID,
    updateBudgetRequest,
    loader,
    error,
    setIsModalOpen,
    notification,
  } = props;
  const [selectedRow, setSelectedRow] = useState({});
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [initialBudgetCost, setInitialBudgetCost] = useState("");
  const [initialBudgetTime, setInitialBudgetTime] = useState("");
  const [changeRequestsCost, setChangeRequestsCost] = useState("");
  const [changeRequestsTime, setChangeRequestsTime] = useState("");
  const [revisedBudgetCost, setRevisedBudgetCost] = useState("");
  const [revisedBudgetTime, setRevisedBudgetTime] = useState("");
  const [pv, setPV] = useState("");
  const [actual, setActual] = useState("");
  const [ev, setEV] = useState("");
  const [etc, setETC] = useState("");
  const [bac, setBAC] = useState("");
  const [cv, setCV] = useState("");
  const [sv, setSV] = useState("");
  const [ProjectId, setProjectId] = useState(projectID);
  const [projectOptions, setProjectOptions] = useState([]);
  const [formErrors, setFormErrors] = useState({
    name: "",
    projectId: "",
  });

  const searchProjectHandler = (value) => {
    if (value) {
      const payload = {
        searchText: value,
      };
      payload.parent = "Budget";
      if (programID) {
        payload.id = programID;
        payload.parent = "Program";
        return;
      }
      if (projectID) {
        payload.id = projectID;
        payload.parent = "Project";
        return;
      }
      if (portfolioID) {
        payload.id = portfolioID;
        payload.parent = "Portfolio";
        return;
      }

      projectService.searchProjectsRequest(payload).then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setProjectOptions(transformedArray);
      });
    } else {
      setProjectOptions([]);
    }
  };

  const handleSave = () => {
    const errors = {};
    if (!name) errors["name"] = `The Name field is required.`;
    if (!projectID) {
      if (!ProjectId) errors["projectId"] = `The Project field is required.`;
    }
    setFormErrors(errors);
    if (Object.keys(errors).length) {
      return;
    }
    const payload = {
      ProjectId: projectID ? projectID : ProjectId.value,
      name,
      code,
      initialBudgetCost: initialBudgetCost || 0,
      initialBudgetTime: initialBudgetTime || 0,
      changeRequestsCost: changeRequestsCost || 0,
      changeRequestsTime: changeRequestsTime || 0,
      revisedBudgetCost: initialBudgetCost
        ? changeRequestsCost
          ? parseInt(initialBudgetCost) + parseInt(changeRequestsCost)
          : initialBudgetCost
        : 0,
      revisedBudgetTime: initialBudgetTime
        ? changeRequestsTime
          ? parseInt(initialBudgetTime) + parseInt(changeRequestsTime)
          : initialBudgetTime
        : 0,
      pv: pv || 0,
      actual: actual || 0,
      ev: ev || 0,
      etc: etc || 0,
      bac: bac || 0,
      cv: ev - actual,
      sv: ev - pv,
    };

    updateBudgetRequest({
      id: notification.id,
      parentID: notification.id,
      parent: "Budget",
      payload,
    });
  };

  const handleInputChange = (value, name) => {
    if (name === "name") setName(value);
  };

  useEffect(() => {
    if (actual && ev) {
      setCV(ev - actual);
    }
    if (ev && pv) {
      setSV(ev - pv);
    }
  }, [actual, ev, pv]);

  useEffect(() => {
    if (name) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        name: "",
      }));
    }
    if (ProjectId) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        projectId: "",
      }));
    }
  }, [ProjectId, name]);

  const fetchBudgetData = async () => {
    budgetService
      .fetchSingleBudgetRequest(notification.id)
      .then((budgetData) => {
        setName(budgetData.name);
        setCode(budgetData.code);
        setInitialBudgetCost(`${budgetData.initialBudgetCost}`);
        setInitialBudgetTime(`${budgetData.initialBudgetTime}`);
        setChangeRequestsCost(`${budgetData.changeRequestsCost}`);
        setChangeRequestsTime(`${budgetData.changeRequestsTime}`);
        setRevisedBudgetCost(`${budgetData.revisedBudgetCost}`);
        setRevisedBudgetTime(`${budgetData.changeRequestsTime}`);
        setPV(`${budgetData.pv}`);
        setActual(`${budgetData.actual}`);
        setEV(`${budgetData.ev}`);
        setETC(`${budgetData.etc}`);
        setBAC(`${budgetData.bac}`);
        setCV(`${budgetData.cv}`);
        setSV(`${budgetData.sv}`);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };

  const handleCancel = () => {
    setFormErrors({});
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (notification.id) {
      fetchBudgetData();
    } else {
      setProjectId("");
      setProjectOptions([]);
      setName("");
      setCode("");
      setInitialBudgetCost("");
      setInitialBudgetTime("");
      setChangeRequestsCost("");
      setChangeRequestsTime("");
      setRevisedBudgetCost("");
      setRevisedBudgetTime("");
      setPV("");
      setActual("");
      setEV("");
      setETC("");
      setBAC("");
      setCV("");
      setSV("");
    }
  }, [notification]);

  const formBody = () => {
    return (
      <>
        <InputUnderline
          placeholder="Enter description"
          isRequired
          value={name}
          error={formErrors.name}
          handleChange={(value) => handleInputChange(value, "name")}
        />
        <InputUnderline
          placeholder="Claim Code"
          value={code}
          handleChange={setCode}
          autoFocus={false}
        />
        {!projectID && (
          <div className="mt-4 w-50">
            <Searchable
              label="Project"
              SelectText="project"
              isRequired
              selectWd="w-75 me-3"
              searchText={searchProjectHandler}
              options={projectOptions}
              defaultVal={ProjectId}
              onChange={(e) => setProjectId(e)}
              errorMessage={formErrors.projectId}
            />
          </div>
        )}
        <h5 className="mt-4 mb-3">Days Info</h5>
        <div>
          <div className="d-flex align-items-start mb-3">
            <div className="w-50 me-3 d-flex align-items-end">
              <Input
                inputwd="w-75 me-2"
                value={`${initialBudgetCost}`}
                handleChange={setInitialBudgetCost}
                label="Initial Budget"
                placeholder="0"
                type="number"
                currency={true}
              />
              <Input
                inputwd="w-25"
                value={`${initialBudgetTime}`}
                type="number"
                handleChange={setInitialBudgetTime}
                label=""
                placeholder="days"
              />
            </div>
            <div className="w-50 d-flex align-items-end">
              <Input
                inputwd="w-75 me-2"
                value={`${changeRequestsCost}`}
                handleChange={setChangeRequestsCost}
                label="Change Request"
                placeholder="0"
                type="number"
                currency={true}
              />
              <Input
                inputwd="w-25"
                value={`${changeRequestsTime}`}
                type="number"
                handleChange={setChangeRequestsTime}
                label=""
                placeholder="days"
              />
            </div>
          </div>
          <div className="w-49 me-3 d-flex align-items-end">
            <Input
              inputwd="w-75 me-2"
              value={
                changeRequestsCost
                  ? parseInt(initialBudgetCost) + parseInt(changeRequestsCost)
                  : initialBudgetCost
              }
              placeholder="0"
              type="number"
              currency={true}
              handleChange={setRevisedBudgetCost}
              label="Revised Budget"
              isDisabled
            />
            <Input
              inputwd="w-25"
              value={
                changeRequestsTime
                  ? parseInt(initialBudgetTime) + parseInt(changeRequestsTime)
                  : initialBudgetTime
              }
              type="number"
              handleChange={setRevisedBudgetTime}
              isDisabled
              placeholder="days"
            />
          </div>
        </div>
        <h5 className="mt-4 mb-3">Amount</h5>
        <div>
          <div className="row align-items-center mb-3 gx-3">
            <div className="col-4">
              <Input
                value={`${actual}`}
                handleChange={setActual}
                label="Actual"
                placeholder="0"
                type="number"
                currency={true}
              />
            </div>
            <div className="col-4">
              <Input
                value={`${pv}`}
                handleChange={setPV}
                label="PV"
                placeholder="0"
                type="number"
                currency={true}
              />
            </div>
            <div className="col-4">
              <Input
                value={`${ev}`}
                handleChange={setEV}
                label="EV"
                placeholder="0"
                type="number"
                currency={true}
              />
            </div>
          </div>
          <div className="row align-items-center mb-3 gx-3">
            <div className="col-4">
              <Input
                value={`${etc}`}
                handleChange={setETC}
                label="ETC"
                placeholder="0"
                type="number"
                currency={true}
              />
            </div>
            <div className="col-4">
              <Input
                value={`${bac}`}
                handleChange={setBAC}
                label="BAC"
                placeholder="0"
                type="number"
                currency={true}
              />
            </div>
          </div>
        </div>
        <h5 className="mt-4 mb-3">Calculated variance</h5>
        <div className="row align-items-center mb-3 gx-3">
          <div className="col-4">
            <Input
              inputClass="BlueFieldBg"
              isDisabled={true}
              value={`${cv}`}
              label="CV"
              placeholder="0"
              type="number"
              currency={true}
            />
          </div>
          <div className="col-4">
            <Input
              inputClass="BlueFieldBg"
              isDisabled={true}
              value={`${sv}`}
              label="SV"
              placeholder="0"
              type="number"
              currency={true}
            />
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Modal
        title="Budget"
        handleCancel={handleCancel}
        handleSave={handleSave}
        body={formBody()}
        isLoading={loader}
        size="large"
        saveBtnLabel="Save"
        cancelBtnLabel="Cancel"
      />
    </>
  );
};

const ScopeItem = (props) => {
  const {
    portfolioID,
    projectID,
    programID,
    allUsers,
    updateScopeRequest,
    error,
    setIsModalOpen,
    notification,
  } = props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const loading = useSelector(scopeStatusLoading);
  const [scopeName, setScopeName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [revisedEndDate, setRevisedEndDate] = useState("");
  const [priority, setPriority] = useState("");
  const [budget, setBudget] = useState("");
  const [completion, setCompletion] = useState("");
  const [phase, setPhase] = useState("");
  const [status, setStatus] = useState("");
  const [refId, setRefId] = useState("");
  const [description, setDescription] = useState("");
  const [ProjectId, setProjectId] = useState(projectID);
  const [projectOptions, setProjectOptions] = useState([]);
  const [showManagerDropdown, setShowManagerDropdown] = useState(false);
  const [resources, setResources] = useState([]);
  const [resourceOptions, setResourceOptions] = useState([]);
  const [assignedResources, setAssignedResources] = useState("");
  const [managerOptions, setManagerOptions] = useState([]);
  const [manager, setManager] = useState(null);
  const [isMilestone, setIsMilestone] = useState(false);
  const [setting] = useState(settings);
  const [formErrors, setFormErrors] = useState({
    scopeName: "",
    startDate: "",
    endDate: "",
    revisedEndDate: "",
    completion: "",
    projectId: "",
  });

  const getRequestPriority = (type) => {
    switch (type) {
      case 1:
        return "Moderate";
      case 2:
        return "High";
      default:
        return "Low";
    }
  };

  const setSelectedReources = (ids) => {
    setResources(ids);
  };

  useEffect(() => {
    if (allUsers) {
      const transformedArray = allUsers.map((obj) => ({
        label: obj.fullName,
        value: obj.id,
        image: obj.profilePictureUrl,
      }));
      setResourceOptions(transformedArray);
    }
  }, [allUsers]);

  const searchHandler = (value) => {
    if (value === "") {
      setResourceOptions([]);
      return;
    }
    // if (value) {
    userService
      .searchUserDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
          //   image: obj.image
        }));
        setResourceOptions(transformedArray);
      })
      .catch(() => {
        setResourceOptions([]);
      });
    // }
  };

  const searchManagerHandler = (value) => {
    if (value === "") {
      setManagerOptions([]);
      return;
    }
    // if (value) {
    userService
      .searchUserDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setManagerOptions(transformedArray);
      })
      .catch(() => {
        setManagerOptions([]);
      });
    // }
  };

  const setRequestPriority = (type) => {
    switch (type) {
      case "Moderate":
        return 1;
      case "High":
        return 2;
      default:
        return 0;
    }
  };

  const handleSave = () => {
    if (!budget) setBudget(null);
    if (!completion) setCompletion(null);
    const errors = {};
    if (startDate && endDate && isDateGreaterThan(startDate, endDate)) {
      errors[
        "endDate"
      ] = `End date must be equal to or greater than start date.`;
    }
    if (
      startDate &&
      revisedEndDate &&
      isDateGreaterThan(startDate, revisedEndDate)
    ) {
      errors[
        "revisedEndDate"
      ] = `Revised end date must be equal to or greater than start date.`;
    }
    if (completion && isNaN(completion)) {
      errors["completion"] = `Completion must be a number.`;
    } else if (completion && (completion < 0 || completion > 100)) {
      errors["completion"] = `Completion must be between 0 and 100.`;
    }
    if (!scopeName) errors["scopeName"] = `The Name field is required.`;
    if (!projectID) {
      if (!ProjectId) errors["projectId"] = `The Project field is required.`;
    }

    setFormErrors(errors);
    if (Object.keys(errors).length) {
      return;
    }
    const payload = {
      Name: scopeName,
      ProjectId: projectID ? projectID : ProjectId.value,
      StartDate: startDate ? startDate : null,
      EndDate: endDate ? endDate : null,
      RevisedEndDate: revisedEndDate ? revisedEndDate : null,
      Priority: setRequestPriority(priority),
      Budget: budget ? budget : 0,
      Completion: completion ? completion : 0,
      Phase: phase,
      Status: status,
      RefId: refId,
      //OwnerId: manager ? manager.value : null,
      Description: description,
      AssignedUsers: resources,
      IsMilestone: isMilestone,
    };

    updateScopeRequest({ sId: notification.id, parent: "Scope", payload });
  };

  const fetchScopeData = async () => {
    scopeService
      .getScopeDetailsRequest({ id: notification.id })
      .then((scopeData) => {
        setScopeName(scopeData.name);
        setStartDate(scopeData.startDate);
        setEndDate(scopeData.endDate);
        setRevisedEndDate(scopeData.revisedEndDate);
        setPriority(getRequestPriority(scopeData.priority));
        setBudget(scopeData.budget);
        setCompletion(scopeData.completion);
        setPhase(scopeData.phase);
        setStatus(scopeData.status);
        setRefId(scopeData.refId);
        setDescription(scopeData.description);
        if (scopeData.users) {
          const newArray = scopeData.users.map((obj) => ({
            value: obj.id,
            label: obj.name,
            image: obj.image,
          }));
          setAssignedResources(newArray);
        } else {
          setAssignedResources("");
        }

        if (scopeData.owner) {
          const manArr = {
            value: scopeData.owner.id,
            label: scopeData.owner.name,
          };
          setManager(manArr);
        } else {
          setManager({});
        }

        if (scopeData.project) {
          const manArr = {
            value: scopeData.project.id,
            label: scopeData.project.name,
          };
          setProjectId(manArr);
        } else {
          setProjectId({});
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
  };

  useEffect(() => {
    if (Object.keys(notification).length > 0) {
      fetchScopeData();
    } else {
      setScopeName("");
      setStartDate("");
      setEndDate("");
      setRevisedEndDate("");
      setPriority("");
      setBudget("");
      setCompletion("");
      setPhase("");
      setStatus("");
      setRefId("");
      setManager([]);
      setAssignedResources([]);
      setDescription("");
      setResources([]);
      setShowManagerDropdown(false);
      setManagerOptions([]);
      setResourceOptions([]);
    }
  }, [notification]);

  const handleCancel = () => {
    setFormErrors({});
    setIsModalOpen(false);
  };

  const handleInputChange = (value, name) => {
    if (name === "startDate") setStartDate(value);
    if (name === "endDate") setEndDate(value);
    if (name === "revisedEndDate") setRevisedEndDate(value);
    if (name === "completion") setCompletion(value);
    if (name === "scopeName") {
      setScopeName(value);
      if (formErrors && value) {
        setFormErrors({
          ...formErrors,
          [name]: "",
        });
      }
    }
  };

  useEffect(() => {
    if (error !== "" && error) {
      Object.keys(error).forEach((key) => {
        if (key === "Name") {
          setFormErrors((prevErrors) => ({
            ...prevErrors,
            scopeName: error[key][0],
          }));
        }
      });
    }
  }, [error]);

  const searchProjectHandler = (value) => {
    if (value === "") {
      setProjectOptions([]);
      return;
    }
    // if (value) {
    const payload = {
      searchText: value,
    };
    payload.parent = "Risk";
    if (programID) {
      payload.id = programID;
      payload.parent = "Program";
    }
    if (projectID) {
      payload.id = projectID;
      payload.parent = "Project";
    }
    if (portfolioID) {
      payload.id = portfolioID;
      payload.parent = "Portfolio";
    }

    projectService
      .searchProjectsRequest(payload)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setProjectOptions(transformedArray);
      })
      .catch(() => {
        setProjectOptions([]);
      });
    // } else {
    //   setProjectOptions([]);
    // }
  };

  const handleCreateResource = (e) => {
    if (resources.length > 0) {
      setResources((previous) => [...previous, e.value]);
    } else {
      setResources([e.value]);
    }
  };

  useEffect(() => {
    if (assignedResources.length > 0) {
      if (typeof assignedResources[0] === "string") {
        setSelectedReources([...assignedResources]);
      } else {
        const resArray = assignedResources.map((obj) => obj.value);
        setSelectedReources([...resArray]);
      }
    }
  }, [assignedResources]);

  const formBody = () => {
    const { inlineItems, overflowItems } = partitionAvatarGroupItems({
      items: resources,
    });
    return (
      <div>
        <InputUnderline
          placeholder="Add scope name"
          value={scopeName}
          error={formErrors.scopeName}
          handleChange={(value) => handleInputChange(value, "scopeName")}
          isRequired
        />
        <div className="mt-3">
          {/* <ModalCheckbox
                label="Mark as Milestone"
                checked={isMilestone}
                setChecked={setIsMilestone}
            /> */}
          <ModalCheckbox
            label={isMilestone ? "Milestone" : "Mark as Milestone"}
            checked={isMilestone}
            setChecked={setIsMilestone}
          />
        </div>
        <div className="ModalAvatarGroup">
          <div className="row align-items-end gx-3">
            <div className="col-4">
              <Searchable
                label="Resources"
                CustomClass="ModalAvatarSearch"
                persona={true}
                multiselect={true}
                searchText={searchHandler}
                SelectText="resources"
                options={resourceOptions}
                defaultVal={assignedResources}
                onChange={(e) => setSelectedReources(e)}
                creatable={true}
                setCreated={(e) => handleCreateResource(e)}
              />
            </div>
            <div className="col-8">
              {/* {inlineItems && (
                  <div className="AvatarGroupWrapper">
                    <AvatarGroup layout="stack">
                      {inlineItems.map((item) => (
                        <AvatarGroupItem
                          size={28}
                          color="colorful"
                          name={item.label}
                          image={{ src: item.image ? item.image : "" }}
                          key={item.label}
                        />
                      ))}
                      {overflowItems && (
                        <AvatarGroupPopover>
                          {overflowItems.map((item) => (
                            <AvatarGroupItem
                              color="colorful"
                              name={item.label}
                              image={{ src: item.image ? item.image : "" }}
                              key={item.label}
                            />
                          ))}
                        </AvatarGroupPopover>
                      )}
                    </AvatarGroup>
                  </div>
                )} */}
            </div>
          </div>
        </div>

        {/* <div className="ModalAvatarGroup">
                      <div className="addAvatarWrapper" onClick={handleAssignManager}>
                          <AddPersonIcon />
                      </div>  
                      {inlineItems &&
                          <div className="AvatarGroupWrapper ms-12">
                              <AvatarGroup layout="stack">
                                  {inlineItems.map((item) => (
                                      <AvatarGroupItem size={28} name={item.label} image={{ src: item.image ? item.image : "" }} key={item.name} />
                                  ))}
                                  {overflowItems && (
                                      <AvatarGroupPopover>
                                          {overflowItems.map((item) => (
                                              <AvatarGroupItem name={item.label} image={{ src: item.image ? item.image : "" }} key={item.name} />
                                          ))}
                                      </AvatarGroupPopover>
                                  )}
                              </AvatarGroup>
                          </div>
                      }
                  </div>
                  {showManagerDropdown && (
                      <div className="row align-items-center mb-4 g-3">
                          <div className="col-4">
                              <Searchable label="Resources" persona={true} multiselect={true} searchText={searchHandler} SelectText="resources" options={resourceOptions} defaultVal={assignedResources} onChange={(e) => setResources(e)} />
                          </div>
                      </div>
                  )} */}
        <div className="row align-items-center gx-3 mb-3">
          <DateRangeWithDuration
            startDate={startDate}
            endDate={endDate}
            revisedEndDate={revisedEndDate}
            onStartDateChange={(value) => handleInputChange(value, "startDate")}
            onEndDateChange={(value) => handleInputChange(value, "endDate")}
            onRevisedEndDateChange={(value) => handleInputChange(value, "revisedEndDate")}
            startDateError={formErrors.startDate}
            endDateError={formErrors.endDate}
            showRevisedEndDate={true}
            icon={<CalendarIcon />}
          />
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <DropDown
              label="Priority"
              options={changeRequestPriorities}
              defaultVal={priority}
              onChange={setPriority}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder={`${getAccountCurrency(setting)} 0`}
              value={budget}
              type="number"
              handleChange={setBudget}
              label="Budget"
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="0 %"
              value={completion}
              type="number"
              handleChange={(value) => handleInputChange(value, "completion")}
              label="Completion"
              errorMessage={formErrors.completion}
            />
          </div>
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter phase"
              value={phase}
              type="text"
              handleChange={setPhase}
              label="Phase"
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter status"
              value={status}
              type="text"
              handleChange={setStatus}
              label="Status"
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter Reference ID"
              value={refId}
              type="text"
              handleChange={setRefId}
              label="Reference ID"
            />
          </div>
        </div>

        <div className="row align-items-center gx-3 mb-3">
          {/* <div className="col-4">
            <Searchable
              label="Scope Manager"
              searchText={searchManagerHandler}
              options={managerOptions}
              SelectText="scope manager"
              defaultVal={manager}
              onChange={setManager}
              creatable={true}
              setCreated={setManager}
            />
          </div> */}
          {!projectID && (
            <div className="col-4">
              <Searchable
                label="Project"
                SelectText="project"
                searchText={searchProjectHandler}
                options={projectOptions}
                defaultVal={ProjectId}
                onChange={(e) => setProjectId(e)}
                errorMessage={formErrors.projectId}
                isRequired
              />
            </div>
          )}
        </div>
        <RichTextEditor
          label="Description"
          content={description}
          onChange={setDescription}
        />
      </div>
    );
  };

  useEffect(() => {
    if (scopeName) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        scopeName: "",
      }));
    }
    if (ProjectId) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        projectId: "",
      }));
    }
  }, [ProjectId, scopeName]);

  return (
    <>
      <Modal
        title="Scope Item"
        handleCancel={handleCancel}
        handleSave={handleSave}
        body={formBody()}
        // isLoading={loading}
        size="large"
        saveBtnLabel="Save"
        cancelBtnLabel="Cancel"
      />
    </>
  );
};

const ActivitySettings = ({ setIsModalOpen }) => {
  const [checked, setChecked] = useState(false);

  // const [title] = useState(Modaltitle);
  const [options] = useState([
    { name: "5 minutes", value: "5" },
    { name: "10 minutes", value: "10" },
    { name: "15 minutes", value: "15" },
  ]);

  const [options2] = useState([
    { name: "Daily", value: "Daily" },
    { name: "Weekly", value: "Weekly" },
    { name: "Monthly", value: "Monthly" },
  ]);

  const [options3] = useState([
    { name: "12:30", value: "12:30" },
    { name: "1:00", value: "1:00" },
    { name: "1:30", value: "1:30" },
  ]);
  const [selectedOptions, setSelectedOptions] = useState(options[0]?.name);

  const formBody = () => {
    return (
      <>
        <div className={styles.settingsCard}>
          <div className="d-flex align-items-start">
            <CheckboxInput
              StyleClass={styles.Checkbox}
              checked={checked}
              setChecked={setChecked}
            />
            <div className={styles.textContent}>
              <h6 className="font-weight-600 mb-1">Upcoming task deadlines</h6>
              <p className="text-xsm-400 subHeading-color">
                Configure when you want to receive notifications for upcoming
                deadlines.
              </p>
            </div>
          </div>
          <DropDown
            // label="Type"
            dropDownwd={styles.dropDownwd}
            options={options}
            placeholder="Select"
            selectedOption={selectedOptions}
            onChange={setSelectedOptions}
          />
        </div>

        <div className={styles.settingsCard}>
          <div className="d-flex align-items-start">
            <CheckboxInput
              StyleClass={styles.Checkbox}
              checked={checked}
              setChecked={setChecked}
            />
            <div className={styles.textContent}>
              <h6 className="font-weight-600 mb-1">
                Reminder for unassigned tasks
              </h6>
              <p className="text-xsm-400 subHeading-color">
                Configure reminder settings for unassigned tasks.
              </p>
            </div>
          </div>
          <DropDown
            // label="Type"
            dropDownwd={styles.dropDownwd}
            options={options2}
            placeholder="Select"
            selectedOption={selectedOptions}
            onChange={setSelectedOptions}
          />
        </div>

        <div className={styles.settingsCard}>
          <div className="d-flex align-items-start">
            <CheckboxInput
              StyleClass={styles.Checkbox}
              checked={checked}
              setChecked={setChecked}
            />
            <div className={styles.textContent}>
              <h6 className="font-weight-600 mb-1">Daily summary</h6>
              <p className="text-xsm-400 subHeading-color">
                Configure the time at which you want to receive the daily
                summary.
              </p>
            </div>
          </div>
          <DropDown
            // label="Type"
            dropDownwd={styles.dropDownwd}
            options={options3}
            placeholder="Select"
            selectedOption={selectedOptions}
            onChange={setSelectedOptions}
          />
        </div>
      </>
    );
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSave = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal
      title="Activity Settings"
      handleCancel={handleCloseModal}
      handleSave={handleSave}
      body={formBody()}
      isLoading={false}
      size="large"
      saveBtnLabel="Save"
      cancelBtnLabel="Cancel"
    />
  );
};



const NotificationModals = (props) => {
  const {
    modalType,
    isCreate,
    setIsModalOpen,
    notification,
    updateBudgetRequest,
    budgetLoader,
    updateRiskRequest,
    riskLoader,
    updateChangeRequest,
    crLoader,
    resourcesShiftsRequest,
    getScopeItemsRequest,
    updateTaskRequest,
    updateScopeRequest,
  } = props;
  const loadModal = () => {
    if (modalType) {
      switch (modalType) {
        case "reminder":
          return (
            <ReminderModal
              setIsModalOpen={setIsModalOpen}
              isCreate={isCreate}
            />
          );
        case "settings":
          return <ActivitySettings setIsModalOpen={setIsModalOpen} />;
        default:
          return "";
      }
    }
    switch (notification.type) {
      case "User":
        return (
          <Resources
            setIsModalOpen={setIsModalOpen}
            notification={notification}
          />
        );
      case "ChangeRequest":
        return (
          <ChangeRequest
            setIsModalOpen={setIsModalOpen}
            notification={notification}
            updateChangeRequest={updateChangeRequest}
            loader={crLoader}
          />
        );
      case "Risk":
        return (
          <Risk
            setIsModalOpen={setIsModalOpen}
            notification={notification}
            updateRiskRequest={updateRiskRequest}
            loader={riskLoader}
          />
        );
      case "CostItem":
        return (
          <Budget
            setIsModalOpen={setIsModalOpen}
            notification={notification}
            updateBudgetRequest={updateBudgetRequest}
            loader={budgetLoader}
          />
        );
      case "Scope":
        return (
          <ScopeItem
            setIsModalOpen={setIsModalOpen}
            notification={notification}
            updateScopeRequest={updateScopeRequest}
          />
        );
      case "Task":
        return (
          <Task
            setIsModalOpen={setIsModalOpen}
            notification={notification}
            updateTaskRequest={updateTaskRequest}
            resourcesShiftsRequest={resourcesShiftsRequest}
            getScopeItemsRequest={getScopeItemsRequest}
          />
        );
      default:
        return "";
    }
  };

  return <>{loadModal()}</>;
};

const mapDispatchToProps = {
  updateBudgetRequest,
  updateCommunicationPlanRequest,
  updateRiskRequest,
  updateChangeRequest,
  resourcesShiftsRequest,
  getScopeItemsRequest: getScope,
  updateTaskRequest: updateTask,
  updateScopeRequest,
};

const mapStateToProps = (state) => {
  const budgetLoader = budgetLoading(state);
  const communicationLoader = communicationPlanStatusLoading(state);
  const crLoader = changeRequestLoading(state);
  const riskLoader = riskStatusLoading(state);
  return { budgetLoader, communicationLoader, riskLoader, crLoader };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationModals);
